import React from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';

import { Api } from 'API/MPWApi';
import LoginForm from 'Pages/login/components/LoginForm';
import { FieldEnum } from 'Common/FieldEnum';

/**
 * Modal component that logs a user in to provide access to certain endpoints
 */
class AccessPrompt extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    onError: PropTypes.func,
    onCancel: PropTypes.func,
    showCancel: PropTypes.bool,
    onUser: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    districtId: (props, propName, componentName) => {
      if (props.isLoggedIn && !Boolean(props[propName])) {
        return new Error(
          `Warning: Failed prop type: The prop \`${propName}\` is marked as required in \`${componentName}\`, but its value is \`${props[propName]}\`.`
        );
      }
    },
  };

  static defaultProps = {
    open: false,
    title: 'Authorize',
    showCancel: false,
    onError: e => {},
    onCancel: () => {},
    onUser: user => {},
    isLoggedIn: false,
  };

  render() {
    const {
      open,
      title,
      showCancel,
      onUser,
      onError,
      onCancel,
      districtId,
    } = this.props;
    return (
      <Modal size="small" open={open}>
        <Header icon="info circle" content={title} />
        <Modal.Content>
          <LoginForm
            initialValues={{
              [FieldEnum.DistrictId]: districtId,
            }}
            hideSettings
            hideForgotPassword
            loginButtonText="Authorize"
            disableDistrict
            onSubmit={async values => {
              try {
                const MPWWebAPI = new Api();
                const response = await MPWWebAPI.loginApi.postLogin(values);
                onUser(response.data.Data);
              } catch (e) {
                onError(e);
              }
            }}
            leftButton={
              showCancel && (
                <Button floated="left" basic onClick={onCancel} type="button">
                  <strong>Cancel</strong>
                </Button>
              )
            }
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export { AccessPrompt };



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/AccessPrompt.js